<template>
    <a-layout class="help-detail">
        <a-layout-header>
            <page-nav></page-nav>
        </a-layout-header>
        <a-layout-content class="help-detail__body">
            <main class="help-detail__inner">
                <button type="button" class="help-detail__back" @click="$router.push('/help')">
                    <icon-left size="18" />
                    <span>{{ $t('help_pages.back_to_help') }}</span>
                </button>
                <h1>{{ $t('help.faq.title') }}</h1>
                <p class="help-detail__intro">{{ $t('help.faq.intro') }}</p>
                <div class="help-detail__list">
                    <article class="help-detail__item">
                        <h2>{{ $t('help.faq.registration.question') }}</h2>
                        <p>{{ $t('help.faq.registration.answer') }}</p>
                    </article>
                    <article class="help-detail__item">
                        <h2>{{ $t('help.faq.documents.question') }}</h2>
                        <p>{{ $t('help.faq.documents.answer') }}</p>
                    </article>
                    <article class="help-detail__item">
                        <h2>{{ $t('help.faq.deposit.question') }}</h2>
                        <p>{{ $t('help.faq.deposit.answer') }}</p>
                    </article>
                    <article class="help-detail__item">
                        <h2>{{ $t('help.faq.security.question') }}</h2>
                        <p>{{ $t('help.faq.security.answer') }}</p>
                    </article>
                </div>
            </main>
        </a-layout-content>
        <a-layout-footer>
            <Footer></Footer>
        </a-layout-footer>
    </a-layout>
</template>

<script>
import PageNav from "@/components/PageNav/PageNav.vue";
import Footer from "@/components/Footer/footer.vue";

export default {
    components: {
        PageNav,
        Footer
    }
};
</script>

<style lang="scss" scoped>
.help-detail,
.help-detail__body {
    background: var(--background-primary);
}

.help-detail__body {
    min-height: 620px;
    padding: 48px 24px 88px;
    box-sizing: border-box;
}

.help-detail__inner {
    width: min(100%, 960px);
    margin: 0 auto;
}

.help-detail__back {
    padding: 0;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border: 0;
    background: transparent;
    color: var(--content-secondary);
    font-size: 14px;
    cursor: pointer;
}

.help-detail__back:hover {
    color: var(--color-primary);
}

.help-detail h1 {
    margin: 34px 0 12px;
    color: var(--content-primary);
    font-size: 36px;
    line-height: 1.35;
}

.help-detail__intro {
    margin: 0 0 34px;
    color: var(--content-secondary);
    font-size: 16px;
    line-height: 1.75;
}

.help-detail__list {
    border-top: 1px solid var(--border-strength-100);
}

.help-detail__item {
    padding: 28px 0;
    border-bottom: 1px solid var(--border-strength-100);
}

.help-detail__item h2 {
    margin: 0;
    color: var(--content-primary);
    font-size: 19px;
    line-height: 1.5;
}

.help-detail__item p {
    margin: 14px 0 0;
    color: var(--content-secondary);
    font-size: 15px;
    line-height: 1.85;
    white-space: pre-line;
    overflow-wrap: anywhere;
}

@media (max-width: 768px) {
    .help-detail__body {
        padding: 34px 20px 64px;
    }

    .help-detail h1 {
        font-size: 28px;
    }
}
</style>
